import React, { useRef }  from "react";
import { connect } from "react-redux";
import Button from "components/button";
import CardItem from "components/card/CardItem";
import { NumberFormatter } from "../../../../utils/index";

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode.react';
import AccountLogo from "components/app-name/AccountLogo";

const PayslipDetails = ({recordData}) => {
	const url = new URL(window.location.href);
	const baseURL = `${url.protocol}//${url.hostname}${url.port ? `:${url.port}` : ''}`;
	
	const totalEarnings = recordData?.incomePaycodeLis?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);
	
	const totalDeductions = recordData?.deductionPaycodeList?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);
	
	const totalAdditionalEarnings = recordData?.additionalIncomePaycodeList?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);
	
	const totalAdditionalDeductions = recordData?.additionalDeductionPaycodeList?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);
	
	const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

	const handleDownloadPdf = async () => {
		if (!componentRef.current) {
			console.error("Component reference is not available");
			return;
		}
	
		const element = componentRef.current;
		const canvas = await html2canvas(element, { scale: window.devicePixelRatio });
		const imgData = canvas.toDataURL("image/png");
		
		const pdf = new jsPDF("p", "mm", "a4");
		const pdfWidth = pdf.internal.pageSize.getWidth();

    	const imgHeight = pdf.internal.pageSize.getHeight();
		const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
	
		if (pdfHeight > imgHeight) {
			let pageHeightLeft = pdfHeight;

			while (pageHeightLeft > 0) {
				pdf.addImage(imgData, "PNG", 0, pageHeightLeft - pdfHeight, pdfWidth, pdfHeight);
				pageHeightLeft -= imgHeight;
				if (pageHeightLeft > 0) {
					pdf.addPage();
				}
			}
		} else {
			pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
		}
	
		pdf.save(`my-payslip-${recordData?.payroll?.pay_date_from}-to-${recordData?.payroll?.pay_date_to}.pdf`);
	};
	
	return ( 
    <>
    	<div ref={componentRef} className="mt-4 grid gap-4">	  
			<div className="w-full h-full p-6 bg-white">
	      	<div className="rounded-[30px] border border-gray-300 w-full h-full p-6 bg-white">
		      	<div className="flex justify-between items-end mb-4">
			      	<div className="p-5">
			      		<AccountLogo accountId={3}/>
			      	</div>
			      	<div className="">
		        		<QRCode value={`${baseURL}/private/my-payslip/${recordData?.ppr_employee_code}/${recordData?.ppr_payroll_id}/${recordData?.ppr_hash}`} size={100}/>
		        	</div>
		    	</div>
			  	   
				<div className="grid grid-cols-2 md:grid-cols-4 mt-4 mb-2">
					<div className="font-medium mb-2">
						<div className="font-bold text-[14px] dark:text-white">Employee ID</div>
						<div className="font-medium text-[14px] ps-3 dark:text-white">{recordData?.ppr_employee_code}</div>
					</div>

					<div className="font-medium mb-2">
						<div className="font-bold text-[14px] dark:text-white">Employee Name</div>
						<div className="font-medium text-[14px] ps-3 dark:text-white">{recordData?.ppr_employee_name}</div>
					</div>

					<div className="font-medium mb-2">
						<div className="font-bold text-[14px] dark:text-white">Hire Date</div>
						<div className="font-medium text-[14px] ps-3 dark:text-white">{recordData?.ppr_employee_hire_date}</div>
					</div>

					<div className="font-medium mb-2">
						<div className="font-bold text-[14px] dark:text-white">Payroll Cut-Off</div>
						<div className="font-medium text-[14px] ps-3 dark:text-white">{`${recordData?.payroll?.pay_date_from} to ${recordData?.payroll?.pay_date_to}`}</div>
					</div>

					<div className="font-medium mb-2 col-span-2">
						<div className="font-bold text-[14px] dark:text-white">Designation</div>
						<div className="font-medium text-[14px] ps-3 dark:text-white">{recordData?.ppr_employee_designation}</div>
					</div>

					<div className="font-medium mb-2">
						<div className="font-bold text-[14px] dark:text-white">Department</div>
						<div className="font-medium text-[14px] ps-3 dark:text-white">{recordData?.ppr_employee_department}</div>
					</div>
				</div>
		        
		        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4">
					<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
		        		<div className="font-bold">Earnings</div>
		        			<div className="flex flex-row gap-4 justify-between" key="basic_pay">
			                    <div className="font-medium">Basic Pay</div>
		                   		<div className="text-right pe-2">{NumberFormatter(recordData?.ppr_base_pay)}</div>
		                  	</div>		        		
						{recordData?.incomePaycodeLis?.map((item) => (
			              (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
		                  	<div className="flex flex-row gap-4 justify-between" key={item.name}>
			                    <div className="font-medium">{item.name} {(item.hours && recordData?.[item.hours] > 0) && `(${NumberFormatter(recordData?.[item.hours])} hrs.)`}</div>
		                   		<div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
		                  	</div>
			                )
			            ))}				            
		        	</div>
					<div className="flex md:hidden flex-col gap-2 p-2 border border-brand-600 rounded mb-2">			        		
			            <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold">Total Earnings</div>
	                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalEarnings + parseFloat(recordData?.ppr_base_pay))}</div>
	                  	</div>
		        	</div>
		        	<div className="flex flex-col gap-2 p-1 border border-brand-600 rounded">
		        		<div className="font-bold">Deductions</div>
		        		{recordData?.deductionPaycodeList?.map((item) => (
			                (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
			                  <div className="flex flex-row gap-4 justify-between" key={item.name}>
			                    <div className="font-medium">{item.name}</div>
			                    <div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
			                  </div>
			                )
			            ))}	                       
		        	</div>
					<div className="flex md:hidden flex-col gap-2 p-2 border border-brand-600 rounded mb-2">			        		
                        <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold">Total Deductions</div>
	                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalDeductions)}</div>
	                  	</div>
		        	</div>
		        </div>
		        <div className="hidden md:grid md:grid-cols-2 gap-4 mb-2">
		        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
			            <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold">Total Earnings</div>
	                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalEarnings + parseFloat(recordData?.ppr_base_pay))}</div>
	                  	</div>
		        	</div>
		        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
                        <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold">Total Deductions</div>
	                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalDeductions)}</div>
	                  	</div>
		        	</div>
		        </div>
		        
		        {(totalAdditionalEarnings !== 0 || totalAdditionalDeductions !== 0) && 
		        (<>
		        	<div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4">
		        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			        		<div className="font-bold">Additional Earnings</div>
			        		{recordData?.additionalIncomePaycodeList?.map((item) => (
			                (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
			                  <div className="flex flex-row gap-4 justify-between" key={item.name}>
			                    <div className="font-medium">{item.name}</div>
			                    <div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
			                  </div>
			                )
			            ))}
			        	</div> 
						<div className="flex md:hidden flex-col gap-2 p-2 border border-brand-600 rounded mb-2">			        		
				            <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Total Additional Earnings</div>			        		
		                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalAdditionalEarnings)}</div>
		                  	</div>
			        	</div>
		        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			        		<div className="font-bold">Additional Deductions</div>
			        		{recordData?.additionalDeductionPaycodeList?.map((item) => (
			                (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
			                  <div className="flex flex-row gap-4 justify-between" key={item.name}>
			                    <div className="font-medium">{item.name}</div>
			                    <div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
			                  </div>
			                )
			            ))}
			        	</div>
						<div className="flex md:hidden flex-col gap-2 p-2 border border-brand-600 rounded mb-2">			        		
	                        <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Total Additional Deductions</div>
			        			<div className="font-bold text-right pe-2">{NumberFormatter(totalAdditionalDeductions)}</div>
		                  	</div>
			        	</div>
			        </div>
						
					<div className="hidden md:grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2">
		        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
				            <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Total Additional Earnings</div>			        		
		                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalAdditionalEarnings)}</div>
		                  	</div>
			        	</div>
		        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
	                        <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Total Additional Deductions</div>
			        			<div className="font-bold text-right pe-2">{NumberFormatter(totalAdditionalDeductions)}</div>
		                  	</div>
			        	</div>
			        </div>				        
		        </>)
		        }

		        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-2">
		        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
		                  <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold">GROSS EARNINGS</div>
		                    <div className="text-right pe-2 font-bold">{NumberFormatter(recordData?.ppr_gross_pay)}</div>
		                  </div>
		        	</div>
		        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
		                  <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold">Withholding Tax</div>
		                    <div className="text-right pe-2 font-bold">{NumberFormatter(recordData?.ppr_withholding_tax)}</div>
		                  </div>
		        	</div>
		        </div>
		        
		        <div className="grid grid-cols-2 gap-4 mb-2">			        	
		        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
		                  <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold">NET PAY</div>
		                    <div className="font-bold text-right pe-2">{NumberFormatter(recordData?.ppr_net_pay)}</div>
		                  </div>			                  
		        	</div>
		        	<div className="flex flex-col gap-2 p-2 rounded">
		                  <div className="flex flex-row gap-4 justify-between">
		                    <div className="font-bold"></div>
		                    <div className="font-bold text-right pe-2"></div>
		                  </div>			                  
		        	</div>
		        </div>		        
      		</div>
			</div>   
      	</div>
	      
      	<div className="dark:bg-intsamis-900 text-right mt-3 px-6">
  			<Button className="btn-primary me-3" onClick={handlePrint}>
                Print
            </Button>
  			<Button className="btn-primary" onClick={handleDownloadPdf}>
                Download as PDF
            </Button>
		</div>	      
    </>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.payrun.payslipDetails?.data,	
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(PayslipDetails);